var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    stroke: "#FFF4E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.996 34l-12-12m12 0l-12 12",
    stroke: "#FFF4E8",
    strokeWidth: 2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIyOCIgY3k9IjI4IiByPSIyNy41IiBzdHJva2U9IiNGRkY0RTgiLz48cGF0aCBkPSJNMzMuOTk2IDM0bC0xMi0xMk0zMy45OTYgMjJsLTEyIDEyIiBzdHJva2U9IiNGRkY0RTgiIHN0cm9rZS13aWR0aD0iMiIvPjwvc3ZnPg==";
export { SvgCloseBtn as ReactComponent };